(function () {
  'use strict';
  if (window.__bcwPackageDedupInitialized) return;
  window.__bcwPackageDedupInitialized = true;
  var previous = new WeakMap();
  var queued = false;
  function label(element) {
    return (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function visible(element) {
    var style = getComputedStyle(element);
    return element.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  }
  function restore(element) {
    var saved = previous.get(element);
    if (!saved) return;
    if (element.style.getPropertyValue('display') === 'none' && element.style.getPropertyPriority('display') === 'important') {
      if (saved.value) element.style.setProperty('display', saved.value, saved.priority);
      else element.style.removeProperty('display');
    }
    element.removeAttribute('data-bcw-package-duplicate');
    previous.delete(element);
  }
  function scan() {
    queued = false;
    var active = document.documentElement.classList.contains('bcw-on');
    document.querySelectorAll('.halo-productBadges').forEach(function (container) {
      var blackPackage = active && Array.prototype.some.call(container.querySelectorAll('.bcw-badges .bcw-badge'), function (badge) {
        return badge.closest('.halo-productBadges') === container && label(badge) === 'pachet' && visible(badge);
      });
      container.querySelectorAll('.custom-badge').forEach(function (badge) {
        if (badge.closest('.halo-productBadges') !== container) return;
        if (!blackPackage || label(badge) !== 'pachet') { restore(badge); return; }
        if (!previous.has(badge)) previous.set(badge, { value: badge.style.getPropertyValue('display'), priority: badge.style.getPropertyPriority('display') });
        badge.setAttribute('data-bcw-package-duplicate', '1');
        badge.style.setProperty('display', 'none', 'important');
      });
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(scan);
  }
  function related(node) {
    var element = node.nodeType === 1 ? node : node.parentElement;
    return !!(element && (element.closest('.halo-productBadges') || element.querySelector('.halo-productBadges')));
  }
  function boot() {
    scan();
    if (window.MutationObserver) {
      new MutationObserver(function (changes) {
        if (changes.some(function (change) {
          if (change.type === 'attributes') {
            var target = change.target;
            if (target.matches('.custom-badge')) return false;
            return !!(target.closest('.bcw-badges') || target.matches('.halo-productBadges') || target.querySelector('.halo-productBadges, .bcw-badges'));
          }
          if (change.target.nodeType === 1 ? change.target.closest('.halo-productBadges') : change.target.parentElement && change.target.parentElement.closest('.halo-productBadges')) return true;
          return Array.prototype.some.call(change.addedNodes, related) || Array.prototype.some.call(change.removedNodes, related);
        })) schedule();
      }).observe(document.body, { childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'], subtree: true });
      new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('pageshow', schedule);
    window.addEventListener('focus', schedule);
    document.addEventListener('bcw:phase', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
